import { HIGH, NORMAL_LOW } from '../constants';

/**
 * @param {number} stageIndicatorValue - Patient stage indicator value
 * @returns Stage
 */
export const getPatientStage = (stageIndicatorValue) => {
  if (stageIndicatorValue >= 90) {
    return '1';
  }
  if (stageIndicatorValue >= 60 && stageIndicatorValue < 90) {
    return '2';
  }
  if (stageIndicatorValue >= 45 && stageIndicatorValue < 60) {
    return '3a';
  }
  if (stageIndicatorValue >= 30 && stageIndicatorValue < 45) {
    return '3b';
  }
  if (stageIndicatorValue >= 15 && stageIndicatorValue < 30) {
    return '4';
  }
  if (stageIndicatorValue < 15) {
    return '5';
  }
  return '';
};

/**
 * @param {number} glycosylatedHemoglobinValue - Glycosylated Hemoglobin value
 * @param {string} stage Patient stage
 * @returns Glycosylated Hemoglobin level
 */
export const getGlycosylatedHemoglobinLevel = (
  glycosylatedHemoglobinValue,
  stage
) => {
  let level = HIGH;
  if ((stage === '1' || stage === '2') && glycosylatedHemoglobinValue < 7) {
    level = NORMAL_LOW;
  }
  if (
    (stage === '3a' || stage === '3b' || stage === '4' || stage === '5') &&
    glycosylatedHemoglobinValue < 7.5
  ) {
    level = NORMAL_LOW;
  }
  return level;
};

export const getAlbumiCreati = (value) => {
  let albmClass = { text: 'A1', desc: 'Albuminuria normal o aumento leve' };
  if (value >= 30 && value < 300)
    albmClass = { text: 'A2', desc: 'Aumento moderado de albuminuria' };
  else if (value >= 300)
    albmClass = { text: 'A3', desc: 'Aumento severo de albuminuria' };
  return albmClass;
};
